import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const _import = file => () => import('@/pages/' + file + '.vue')

export default new Router({
  routes: [
    {
      path: "/",
      component: _import("home/index"),
      redirect: "index",
      children: [
        {
          path: "index",
          component: _import("Index/index"),
          // meta:{ "title":"首页" },
        },
        {
          path: "products",
          component: _import("products/index"),
          // meta:{ "title":"" },
        },
        {
          path: "company",
          component: _import("company/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "news",
          component: _import("news/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "products",
          component: _import("products/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "advantage",
          component: _import("advantage/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "network",
          component: _import("network/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "cooperation",
          component: _import("cooperation/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "advantage",
          component: _import("advantage/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "joins",
          component: _import("joins/index"),
          // meta:{ "title":"动态" },
        },
        {
          path: "joins/:id",
          component: _import("joins/details"),
        },
        {
          path: "news/:id",
          component: _import("news/details"),
        },
        {
          path: "company/allStaffStyle",
          component: _import("staffStyle/index"),
        },
        // {
        //     path:'',
        //     component:_import('About/index'),
        //     // meta:{ "title":"关于" },
        //     children:[
        //         {
        //             path:'feature',
        //             component:_import('About/Feature/index'),
        //             // meta:{ "title":"特点" }
        //         },
        //         {
        //             path:'team',
        //             component:_import('About/Team/index'),
        //             // meta:{ "title":"团队" }
        //         },
        //     ]
        // },
      ],
    },

    {
      path: "/404",
      component: _import("ErrorPages/404"),
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});